<template>
  <div v-if="showDebug" class="debug-panel">
    <button @click="toggleDebug" class="debug-toggle">{{ expanded ? 'Hide' : 'Show' }} Debug</button>
    <div v-if="expanded" class="debug-content">
      <h4>Debug Info - Stage {{ stageNumber }}, Page {{ pageNumber }}</h4>
      
      <div class="debug-section">
        <h5>Questions 21-23 Status:</h5>
        <table>
          <tr>
            <th>Question ID</th>
            <th>Value</th>
            <th>Type</th>
            <th>Rendered?</th>
          </tr>
          <tr>
            <td>21a</td>
            <td>{{ getAnswer('21a') }}</td>
            <td>{{ typeof getAnswer('21a') }}</td>
            <td>{{ isQuestionRendered('21a') ? '✅' : '❌' }}</td>
          </tr>
          <tr>
            <td>21b</td>
            <td>{{ getAnswer('21b') }}</td>
            <td>{{ typeof getAnswer('21b') }}</td>
            <td>{{ isQuestionRendered('21b') ? '✅' : '❌' }}</td>
          </tr>
          <tr>
            <td>22a</td>
            <td>{{ getAnswer('22a') }}</td>
            <td>{{ typeof getAnswer('22a') }}</td>
            <td>{{ isQuestionRendered('22a') ? '✅' : '❌' }}</td>
          </tr>
          <tr>
            <td>22b</td>
            <td>{{ getAnswer('22b') }}</td>
            <td>{{ typeof getAnswer('22b') }}</td>
            <td>{{ isQuestionRendered('22b') ? '✅' : '❌' }}</td>
          </tr>
          <tr>
            <td>23a</td>
            <td>{{ getAnswer('23a') }}</td>
            <td>{{ typeof getAnswer('23a') }}</td>
            <td>{{ isQuestionRendered('23a') ? '✅' : '❌' }}</td>
          </tr>
          <tr>
            <td>23b</td>
            <td>{{ getAnswer('23b') }}</td>
            <td>{{ typeof getAnswer('23b') }}</td>
            <td>{{ isQuestionRendered('23b') ? '✅' : '❌' }}</td>
          </tr>
        </table>
      </div>

      <div class="debug-section">
        <h5>Conditional Questions:</h5>
        <p><strong>3a (Country):</strong> {{ getAnswer('3a') }}</p>
        <p><strong>21a (First trip):</strong> {{ getAnswer('21a') }}</p>
        <p><strong>21b should show if:</strong> 21a = "No" AND 3a != "99900"</p>
        <p><strong>21b condition met?</strong> {{ is21bConditionMet() ? '✅ YES' : '❌ NO' }}</p>
      </div>

      <div class="debug-section">
        <h5>All Current Questions on Page:</h5>
        <ul>
          <li v-for="q in currentQuestions" :key="q.id">
            {{ q.id }} - {{ q.type }} - {{ q.question.substring(0, 50) }}...
          </li>
        </ul>
      </div>

      <div class="debug-section">
        <h5>All Answers:</h5>
        <pre>{{ JSON.stringify(getAllAnswers(), null, 2) }}</pre>
      </div>

      <div class="debug-section">
        <button @click="testSubmit" class="btn btn-primary">Test Submit (Console)</button>
        <button @click="fillTestData" class="btn btn-secondary">Fill Test Data</button>
      </div>
    </div>
  </div>
</template>

<script>
import surveyService from '@/services/surveyService';

export default {
  props: {
    stageNumber: Number,
    pageNumber: Number,
    currentQuestions: Array
  },
  data() {
    return {
      showDebug: true,
      expanded: false
    };
  },
  methods: {
    toggleDebug() {
      this.expanded = !this.expanded;
    },
    getAnswer(questionId) {
      const answer = surveyService.getAnswer(questionId);
      if (answer === undefined || answer === null || answer === '') {
        return '(empty)';
      }
      return JSON.stringify(answer);
    },
    getAllAnswers() {
      return surveyService.getAnswers();
    },
    isQuestionRendered(questionId) {
      return this.currentQuestions.some(q => q.id === questionId);
    },
    is21bConditionMet() {
      const answer21a = surveyService.getAnswer('21a');
      const answer3a = surveyService.getAnswer('3a');
      
      // 21b shows if: 21a = "No" AND 3a != "99900"
      const condition1 = answer21a === 'No';
      const condition2 = answer3a !== '99900';
      
      console.log('21b Condition Check:', {
        '21a': answer21a,
        '3a': answer3a,
        'condition1 (21a=No)': condition1,
        'condition2 (3a!=99900)': condition2,
        'both met': condition1 && condition2
      });
      
      return condition1 && condition2;
    },
    testSubmit() {
      console.log('=== TEST SUBMIT ===');
      console.log('All Answers:', surveyService.getAnswers());
      console.log('Questions 21-23:', {
        '21a': surveyService.getAnswer('21a'),
        '21b': surveyService.getAnswer('21b'),
        '22a': surveyService.getAnswer('22a'),
        '22b': surveyService.getAnswer('22b'),
        '23a': surveyService.getAnswer('23a'),
        '23b': surveyService.getAnswer('23b')
      });
    },
    fillTestData() {
      surveyService.setAnswer('21a', 'No');
      surveyService.setAnswer('21b', 5);
      surveyService.setAnswer('22a', 45);
      surveyService.setAnswer('22b', 'Male');
      surveyService.setAnswer('23a', 80000);
      surveyService.setAnswer('23b', '99900');
      
      alert('Test data filled! Check the debug panel.');
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
.debug-panel {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  background: white;
  border: 2px solid #007bff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
}

.debug-toggle {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  width: 100%;
  text-align: left;
  font-weight: bold;
  border-radius: 6px 6px 0 0;
}

.debug-toggle:hover {
  background: #0056b3;
}

.debug-content {
  padding: 15px;
  font-size: 12px;
}

.debug-section {
  margin-bottom: 20px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 4px;
}

.debug-section h5 {
  margin-top: 0;
  color: #007bff;
  font-size: 14px;
}

.debug-section table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
}

.debug-section table th,
.debug-section table td {
  border: 1px solid #dee2e6;
  padding: 5px;
  text-align: left;
}

.debug-section table th {
  background: #007bff;
  color: white;
}

.debug-section pre {
  background: #fff;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
  font-size: 10px;
  max-height: 200px;
}

.debug-section ul {
  margin: 0;
  padding-left: 20px;
}

.debug-section button {
  margin-right: 10px;
  margin-top: 10px;
}
</style>
